import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	valueLabel: {
		color: colors.blue[800],
		marginBottom: "16px"
	},
	valueContainer: {
		width: "100%",
		paddingTop: "13px",
		paddingBottom: "16px",
		paddingLeft: "14px",
		paddingRight: "14px",
		backgroundColor: colors.blue[50],
		borderRadius: "11px"
	}
})

export default useStyles
